export default "__VITE_ASSET__K4$2Zp1j__"